<template>
<div class="card">
   <h6>YOUR CURRENT ENERGY SUPPLY</h6>
   <h4>Gas Usage</h4>

   <uiv-tabs justified @change="onUsageTabChange(usageTab)" v-model="usageTab">
      <uiv-tab>
        <div slot="title">
          Actual Figures
          <button type="button" class="btn-i" v-if="quote.gasUsage.usageType == 1" v-uiv-tooltip.right="'If you think that your gas consumption is incorrect, please refer to to your latest bill'">i</button>
          <button type="button" class="btn-i" v-if="quote.gasUsage.usageType == 0" v-uiv-tooltip.right="'You will find your gas spend on your latest bill'">i</button>
        </div>

        <div class="row" v-if="quote.gasUsage.usageType == 1 && usageProvided == quote.gasUsage.usage">
          <div class="col-xs-12">
            <p class="_margin-bottom-0">Gas consumption is based on your actual annual usage</p>

            <small v-if="usageProvided">(Check that you are happy with gas kWh consumption provided)</small>
            <uiv-btn v-uiv-popover.hover-focus.bottom="{ content: 'We\'ve got this information from your supplier via Xoserve. We don\'t have any sensitive data, just your gas usage which helps us give you more accurate prices.' }" type="link" size="xs">How do we know this?</uiv-btn>
          </div>
        </div>

         <div class="row _margin-top-30">
            <div class="col-sm-4 _margin-bottom-10">
               <select-list
                  id="gasUsageUsageType"
                  v-model="quote.gasUsage.usageType"
                  :list="usageTypeList"
                  @change="onReset()"
               />
            </div>

            <div class="col-xs-12 col-sm-3 _margin-bottom-10">
               <validation-messages label="Spend" :$v="$v.cost" v-if="quote.gasUsage.usageType == 0">
                  <div class="input-group left">
                     <div class="input-group-addon">£</div>
                     <form-field
                        id="gasUsageCost"
                        type="number"
                        v-model="quote.gasUsage.cost"
                        :error="$v.cost.$error"
                        @change="$v.cost.$touch()"
                     />
                  </div>
               </validation-messages>

               <validation-messages label="kWh" :$v="$v.usage" v-if="quote.gasUsage.usageType == 1">
                  <div class="input-group right">
                     <form-field
                        id="gasUsageUsage"
                        type="number"
                        v-model="quote.gasUsage.usage"
                        :error="$v.usage.$error"
                        @change="$v.usage.$touch()"
                     />
                     <div class="input-group-addon">kWh</div>
                  </div>
               </validation-messages>
            </div>

            <div class="col-sm-5">
              <select-list
                 id="gasUsageUsageUnit"
                 v-model="quote.gasUsage.usageUnit"
                 :list="usageUnitList"
                 @change="onUnitChange"
              />
            </div>
         </div>
      </uiv-tab>

      <uiv-tab title="Help Me Estimate" :disabled="quote.gasUsage.usageType == 0">
         <div v-show="quote.gasUsage.usage !== ''">
            <h6 class="_margin-bottom-10">Gas Usage</h6>
            <h4 class="_margin-top-0">{{ quote.gasUsage.usage | number }} <small>kWh</small></h4>

            <uiv-btn type="ghost"
               size="sm"
               class="_margin-bottom-20"
               @click="onEstimate">New Estimate</uiv-btn>
         </div>

         <div v-show="quote.gasUsage.usage === ''">
            <p>We can provide you an annual consumption estimate by answering a few short questions</p>

            <uiv-btn type="ghost"
               size="sm"
               class="_margin-bottom-20"
               @click="onEstimate">Help Me Estimate</uiv-btn>
         </div>

         <help-me-estimate
            ref="helpEstimate"
            @onClose="onCloseModal" />
      </uiv-tab>

      <uiv-tab title="Use Ofgem Averages" :disabled="quote.gasUsage.usageType == 0">
         <div class="row _margin-top-30">
            <div class="col-xs-4 col-md-3" v-for="item in ofgemAverageList" :key="item.label">
               <radio-button v-model="quote.gasUsage.usage"
                              :value="item.value"
                              :error="$v.usage.$error">{{ item.label }}</radio-button>
            </div>
         </div>
      </uiv-tab>
   </uiv-tabs>
</div>
</template>

<script>
import RadioButton from '../../../../base/components/forms/RadioButton';
import HelpMeEstimate from './HelpMeEstimate';

import { mapState, mapActions, mapGetters } from 'vuex';

export default {
  name: 'UsageGas',
  data () {
    return {
      requesting: false,
      usageTab: 0,
      estimateModalOpen: false
    };
  },
  props: {
    $v: Object
  },
  computed: {
    ...mapGetters({
      is02Meter: 'quote/is02Meter'
    }),
    ...mapState({
      ofgemAverageList: ({ ofgem_averages }) => ofgem_averages.averages.gas,
      quote: ({ quote }) => quote,
      usageTypeList: ({ lookups }) => lookups.usageTypes,
      usageUnitList: ({ lookups }) => lookups.usageUnits,
      usageProvided: ({ quote }) => {
          const address = quote.address.parts;
          if(!address) return false;
          const gasdetails = address.gasdetails.find(({ isDomestic }) => isDomestic) || {};

          return gasdetails.mpaq;
      }
    })
  },
  methods: {
    ...mapGetters({
      quoteType: 'quote/quoteType'
    }),
    ...mapActions({
      getEstimateList: 'lookups/getEstimateList'
    }),
    onReset () {
      if(this.usageTab != 0) return;
      this.quote.gasUsage.usageUnit = 1;
      this.quote.electricityUsage.usageType = this.quote.gasUsage.usageType;

      this.quote.gasUsage.cost = '';
      this.quote.electricityUsage.usage = '';
      this.quote.electricityUsage.cost = '';

      if(!this.quote.gasUsage.usage && this.usageProvided) {
         this.quote.gasUsage.usage = this.usageProvided;
      } else {
         this.quote.gasUsage.usage = '';
      }
    },
    onUnitChange() {
      if(this.quote.gasUsage.usageType == 1 && this.quote.gasUsage.usageUnit == 1) {
         this.quote.gasUsage.usage = this.usageProvided;
      } else {
         this.quote.gasUsage.usage = '';
      }
    },
    onEstimate () {
      this.$refs.helpEstimate.openModal();
    },
    onUsageTabChange (index, type) {
      if (index === 1) {
        this.getEstimateList();
      }

      if (index === 0) {
         this.onReset();
         this.onUnitChange();
      }

      if (index != 0) {
         this.quote.gasUsage.usageType = 1;
         this.quote.gasUsage.usage = '';
         this.quote.gasUsage.cost = '';
         this.quote.electricityUsage.usageType = 1;
         this.quote.electricityUsage.usage = '';
         this.quote.electricityUsage.cost = '';
         this.quote.gasUsage.usageUnit = 1;
         this.quote.electricityUsage.usageUnit = 1;
         this.$v.gasUsage.$reset();
         this.$v.electricityUsage.$reset();
      }
    },
    onCloseModal ({ gasUsage }) {
      this.onReset();
      this.quote.gasUsage.usage = gasUsage;
    }
  },
  components: {
    RadioButton,
    HelpMeEstimate
  }
};
</script>

<style lang="scss">
</style>
